import type { DriverRecord } from '../../../types'
import { formatEuro } from '../../../utils/format'
import type { RowAction } from '../../../components/ui/RowActionsMenu'
import { DriverActions } from './DriverActions'
import { DriverIdentity } from './DriverIdentity'
import { DriverStat } from './DriverStat'
import { DriverVehicle } from './DriverVehicle'
import { DRIVER_GRID } from './driversLayout'

type DriverCardProps = {
  driver: DriverRecord
  actions: RowAction[]
}

export const DriverCard = ({ driver, actions }: DriverCardProps) => {
  const subject = `${driver.code} — ${driver.name}`

  return (
    <article
      className="grid h-[106px] w-full items-center justify-between rounded-[8px] bg-white px-[25px]"
      style={{ gridTemplateColumns: DRIVER_GRID }}
    >
      <DriverIdentity driver={driver} />
      <DriverVehicle vehicle={driver.vehicle} />
      <DriverStat emphasis="figure" label="Income" value={formatEuro(driver.incomeEur)} />
      <DriverStat
        emphasis="plain"
        label="Experience"
        value={`${driver.experienceYears} Years`}
      />
      <DriverActions
        actions={actions}
        subject={subject}
      />
    </article>
  )
}
